export const filterCategories = [
  { id: 1, checked: false, label: "grocery&Frozen", value: "Grocery & Frozen" },
  { id: 4, checked: false, label: "freshVegetable", value: "Fresh Vegetable" },
  { id: 2, checked: false, label: "freshFruits", value: "Fresh Fruits" },
  { id: 3, checked: false, label: "fruitJuices", value: "Fruit Juices" },
  { id: 6, checked: false, label: "salads", value: "Salads" },
  { id: 7, checked: false, label: "freshMeat", value: "Fresh Meat" },
  { id: 8, checked: false, label: "butter&Egg", value: "Butter & Egg" },
  { id: 9, checked: false, label: "milkCream", value: "Milk Cream" },
  { id: 11, checked: false, label: "oil&Vinegars", value: "Oil & Vinegars" },
  { id: 12, checked: false, label: "bread&Bakery", value: "Bread & Bakery" },
  { id: 13, checked: false, label: "snacksItem", value: "Snacks Item" },
  { id: 14, checked: false, label: "fish", value: "Fish" },
];

export const filterBrands = [
  { id: 1, checked: false, label: "nestFood", value: "NestFood" },
  { id: 4, checked: false, label: "pepsiCo", value: "PepsiCo Vegetable" },
  { id: 2, checked: false, label: "nestle", value: "Nestle" },
  { id: 3, checked: false, label: "JBS", value: "JBS" },
  { id: 6, checked: false, label: "tysonFoods", value: "Tyson Foods" },
  { id: 7, checked: false, label: "cargill", value: "Cargill" },
  { id: 8, checked: false, label: "molsonCoors", value: "Molson Coors" },
  { id: 9, checked: false, label: "kelloggCo", value: "Kellogg Co" },
  { id: 11, checked: false, label: "goldenStateFoods", value: "	Golden State Foods" },
  { id: 12, checked: false, label: "hersheyCo", value: "Hershey Co" },
];
